export const _createFieldConfig = ({
  isBackpay,
  concattedMonthYear,
  objectData,
}) => {
  const { payrollType, payItem } = objectData;
  const formatted = `${payrollType} (${concattedMonthYear})`;

  return {
    payrollTax: (item, dates) =>
      isBackpay
        ? (dates ?? []).map(
            (date, idx) =>
              `${payrollType} ${payItem} ${date}: ${item?.tax?.[idx] ?? 0}`
          )
        : `${payrollType} ${payItem} ${concattedMonthYear}: ${item?.tax ?? 0}`,

    monthlyTax: (item, dates) =>
      isBackpay
        ? (dates ?? []).map(
            (date, idx) => `${payrollType} (${date}): ${item?.tax?.[idx] ?? 0}`
          )
        : `${formatted}: ${item?.tax ?? 0}`,

    annualTax: (item, dates) =>
      isBackpay
        ? (dates ?? []).map(
            (date, idx) =>
              `${payrollType} (${date}): ${item?.taxDue?.[idx] ?? 0}`
          )
        : `${formatted}: ${item?.taxDue ?? 0}`,
    netOfMandatory: (item, dates) =>
      isBackpay
        ? (dates ?? []).map(
            (date, idx) =>
              `${payrollType} (${date}): ${item?.netOfMandatory?.[idx] ?? 0}`
          )
        : `${formatted}: ${item?.netOfMandatory ?? 0}`,
    netEarned: (item, dates) =>
      isBackpay
        ? (dates ?? []).map(
            (date, idx) =>
              `${payrollType} (${date}): ${item?.netEarned?.[idx] ?? 0}`
          )
        : `${formatted}: ${item?.netEarned ?? 0}`,
    monthlyPayCode: (item, dates) =>
      isBackpay
        ? (dates ?? []).map(
            (date, idx) =>
              `${payrollType} (${date}): ${item?.payCode?.[idx] ?? 0}`
          )
        : `${formatted}: ${item?.payCode ?? 0}`,
    earnedForThePeriod: (item, dates) =>
      isBackpay
        ? (dates ?? []).map(
            (date, idx) =>
              `${payrollType} (${date}): ${
                item?.earnedForThePeriod?.[idx] ?? 0
              }`
          )
        : `${formatted}: ${item?.earnedForThePeriod ?? 0}`,
    oldRate: (item, dates) =>
      isBackpay
        ? (dates ?? []).map((date) => `${date}: ${item?.oldRate ?? 0}`)
        : `${concattedMonthYear}: ${item?.oldRate ?? 0}`,
    mandatoryDeductions: (item, dates) =>
      isBackpay
        ? (dates ?? []).flatMap((date, idx) =>
            (item?.contributions ?? []).flatMap((entry) => {
              const [key, value] = entry.split(":").map((s) => s.trim());
              if (key.toLowerCase() === "pagibig") return [];

              const values = value.split(",");
              return [
                `${payrollType} ${payItem} ${date} (${key}): ${
                  values[idx] ?? ""
                }`,
              ];
            })
          )
        : (item?.contributions ?? []).flatMap((entry) => {
            const [key, value] = entry.split(":").map((s) => s.trim());
            if (key.toLowerCase() === "pagibig") return [];

            const values = value.split(",");
            return [
              `${payrollType} ${payItem} ${concattedMonthYear} (${key}): ${values}`,
            ];
          }),
    daysInAmonth: (item, dates) =>
      isBackpay
        ? (dates ?? []).map(
            (date, idx) => `${date}: ${item?.daysInAMonth?.[idx] ?? 0}`
          )
        : `${concattedMonthYear}: ${item?.daysInAMonth ?? 0}`,
    gsisInsuredDays: (item, dates) =>
      isBackpay
        ? (dates ?? []).map(
            (date, idx) =>
              `${payrollType}-${payItem} ${date}: ${
                item?.gsisInsuredDays?.[idx] ?? 0
              }`
          )
        : `${payrollType}-${payItem} ${concattedMonthYear}: ${
            item?.gsisInsuredDays ?? 0
          }`,
    earnedBasic: (item, dates) =>
      isBackpay
        ? (dates ?? []).map(
            (date, idx) =>
              `${payrollType} (${date}) - ${item?.earnedBasic?.[idx] ?? 0}`
          )
        : `${payrollType} (${concattedMonthYear}) - ${item?.earnedBasic ?? 0}`,
    daysToBeDeducted: (item, dates) =>
      isBackpay
        ? (dates ?? []).map(
            (date, idx) =>
              `${payrollType} (${date}) - ${item?.daysToBeDeducted?.[idx] ?? 0}`
          )
        : `${payrollType} (${concattedMonthYear}) - ${
            item?.daysToBeDeducted ?? 0
          }`,
    halfDaysToBeDeducted: (item, dates) =>
      isBackpay
        ? (dates ?? []).map(
            (date, idx) =>
              `${payrollType} (${date}) - ${
                item?.halfDaysToBeDeducted?.[idx] ?? 0
              }`
          )
        : `${payrollType} (${concattedMonthYear}) - ${
            item?.halfDaysToBeDeducted ?? 0
          }`,
    halfDaysToBeDeducted: (item, dates) =>
      isBackpay
        ? (dates ?? []).map(
            (date, idx) =>
              `${payrollType} (${date}) - ${
                item?.halfDaysToBeDeducted?.[idx] ?? 0
              }`
          )
        : `${payrollType} (${concattedMonthYear}) - ${
            item?.halfDaysToBeDeducted ?? 0
          }`,
    minutesToBeDeducted: (item, dates) =>
      isBackpay
        ? (dates ?? []).map(
            (date, idx) =>
              `${payrollType} (${date}) - ${
                item?.minutesToBeDeducted?.[idx] ?? 0
              }`
          )
        : `${payrollType} (${concattedMonthYear}) - ${
            item?.minutesToBeDeducted ?? 0
          }`,
  };
};
